export default __webpack_public_path__ + "static/media/warning--curve-out-intersection-left--g1.e1afa97c.png";